export default __webpack_public_path__ + "static/media/image@3x.230793e9.png";